import { toCurrencySymbol } from '@modules/src/panel/PanelUtils'

/**
 * Single entry point for turning the operator currency into something printable.
 *
 * The game used to carry its own ISO table, which drifted from the framework one and mapped the
 * Gulf currencies to their Arabic glyphs. Those glyphs are right-to-left, so once concatenated with
 * an amount the bidirectional algorithm reordered the run and the decimal separator surfaced on the
 * wrong side ("‎.200.00" instead of "AED 200.00"). The framework table prints the Latin code for
 * those currencies, which is also what the operator asked to see.
 */
export const toCurrency = (currencyHex: string): string => toCurrencySymbol(currencyHex)
